import React from 'react';
import PopupComponent from '../src/PopupComponent';
import { Helmet } from 'react-helmet';  
import ContactForm from './components/ContactForm';
import './styles/main.scss';

function Products() {
  return (
    <div className="products-page">
      <Helmet>
        <title>Products - Mevedir</title>
        <meta name='description' content='Explore our range of organic products sourced directly from the Himalayas.'/>
      </Helmet>
      <PopupComponent />
    </div>
  );
}

export default Products;